import Vue from 'vue'
import axios from 'axios'

import utils from '../utils/utils'

import service from '../service'
import store from '../store'

const instance = axios.create({
    timeout: 20000
});
const prefix = process.env.VUE_APP_PREFIX;
let lockblank = false;

instance.defaults.baseURL = process.env.VUE_APP_URL;

window.isRefreshing = false;
let refreshSubscribers = []

instance.interceptors.request.use(function (config) {
    let url = config.url;

    let authToken = localStorage.getItem(prefix+'authToken');
    if (authToken) {
        config.headers.Authorization = "Bearer " + authToken;
        if(Vue.prototype.$platform === "android"){
          config.headers['X-Client-Id'] = "android-h5";
          localStorage.setItem(prefix+"appname","O2Onativeapp");
        }else if(Vue.prototype.$platform === "miniProgram"){
          config.headers['X-Client-Id'] = "mini-app";
          localStorage.setItem(prefix+"appname","O2Owechatapp");
        }else{
          config.headers['X-Client-Id'] = "mini-app" //"h5";
          localStorage.setItem(prefix+"appname","O2Owechatapp");
        }
        
        if (utils.isTokenExpired() && url && url.indexOf("refresh") === -1) {
          if (!window.isRefreshing) {
              window.isRefreshing = true;
              service.toRefreshToken({
                token: localStorage.getItem(prefix+'refreshToken'),
                clientSecret: process.env.VUE_APP_CLIENTSECRET
              }).then(res => {
                  if(res.status === 200){
                      window.isRefreshing = false;
                      config.headers.Authorization = "Bearer " + res.result.accessToken;

                      let accessTokenExpiration = (new Date()).getTime() + 20 * 60 * 1000;

                      localStorage.setItem(prefix+"authToken", res.result.accessToken)
                      localStorage.setItem(prefix+"refreshToken", res.result.refreshToken)
                      localStorage.setItem(prefix+"expriredAt", res.result.accessTokenExpiration || accessTokenExpiration)

                      onRrefreshed(res.result.accessToken)
                  }else{
                      localStorage.removeItem(prefix+"refreshToken")
                      window.isRefreshing = false;
                      store.dispatch("user/logout")
                      // $router.push({path:"/login"})
                  }
              }).catch(err => {
                  // Vue.prototype.$Toast(err);
                  /*清除本地保存的auth*/
                  localStorage.removeItem(prefix+"refreshToken")
                  onRrefreshed()
                  window.isRefreshing = false
                  store.dispatch("user/logout")
                  // $router.push({path:"/login"})
                })
          }

          let retry = new Promise((resolve, reject) => {
              subscribeTokenRefresh((token) => {
                if(token){
                  config.headers.Authorization = 'Bearer ' + token
                }else{
                  config.headers.Authorization = ""
                }
                  
                  resolve(config)
              })
          })
          return retry
      }
    }

    return config;

}, function (error) {
    return Promise.reject(error);
});


instance.interceptors.response.use((res) => {
  return Promise.resolve(res.data)
}, (error) => {
  if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout') > -1){   // 判断请求异常信息中是否含有超时timeout字符串
    if(!lockblank){
      let errorUrl = error.config && error.config.url || ""
      service.getStatisCommon('evn_blank_page',{
        ed:"error timeout;"+errorUrl
      });
      lockblank = true;
      setTimeout(()=>{
        lockblank = false
      },5000)
    }
    
    Vue.prototype.$Toast("请求超时，请稍后重试~");
    return Promise.reject('neterror')
  }

  if(!error.response){
    return Promise.reject('neterror')
  }
  
    //http异常
    let errdata = error.response.data
    
    // 用户被删除
    if(errdata.status === 409){
      store.dispatch("user/logout")
    }

    if(errdata.status === 401){
      console.log('401')
      store.dispatch("user/logout")
    }

    
    
    // if(errdata.status !== 200 && errdata.message){
    //   Vue.prototype.$Toast(errdata.message);
    // }
    return Promise.reject(errdata);
})

function onRrefreshed (token) {
  refreshSubscribers.map(cb => cb(token))
}

/*push所有请求到数组中*/
function subscribeTokenRefresh (cb) {
  refreshSubscribers.push(cb)
}

export default instance